module.exports = __webpack_public_path__ + "img/tf_center_001.4a8c4245.png";